<style lang="scss" scoped>
.success-popover {
    background: var(--dark);
    position: fixed;
    top: -100vh;
    left: 0;
    width: 100vw;
    height: 100vh;
    margin: 0 !important;
    z-index: 1000;
    cursor: initial;
    pointer-events: all;
    transition: top 0.15s ease-in-out;

    h2 {
        font-size: 4rem;
        font-weight: 600;
        line-height: 1.2;

        @media screen and (min-width: 1200px) {
            h2 {
                line-height: 70px;
            }
        }
    }

    p {
        font-size: 1.5rem;
        line-height: 1.5;
    }

    a,
    span  {
        font-size: 1rem;
        font-weight: 600;
        line-height: 1.1rem;
    }

    &.active {
        top: 0;
    }
}
</style>

<template>
    <div class="success-popover">
        <div class="container h-100">
            <div class="row h-100 align-items-center">
                <div class="col-12">
                    <h2 class="text-white mb-40" v-html="title"></h2>
                    <p class="text-white font-weight-light mb-40" v-html="description"></p>
                    <a :href="route('nl.home')" class="btn btn-accent text-white arrow-right">
                        <span v-html="cta"></span>
                        <span v-html="svg('arrow-right', 'arrow-right')"></span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            required: true
        },

        description: {
            type: String,
            required: true
        },

        cta: {
            type: String,
            required: true
        }
    }
}
</script>